export default {
  ImportQuestions: require('./ImportQuestions').default,
  ImportQuestionGroups: require('./ImportQuestionGroups').default,
}